import { useState } from "react";
import moment from "moment";
import { convertToTitleCase, getCSRAdminPortalPae } from "js/formatting";
import CardAlertBase from "components/General/CardAlertBase";
import SiteWideAlertModal from "components/CSRAdmin/ModalDialogs/SiteWideAlertModal";
import { useTranslation } from "react-i18next";

export default function ExpiredAlert({ alert }) {
  const [openAlertMessage, setOpenAlertMessage] = useState(false);
  const { t } = useTranslation();
  const ViewMessage = () => {
    return (
      <button
        className="ml-2 text-sm text-ui-blue underline"
        onClick={() => setOpenAlertMessage(true)}
      >
        {t("AgentCSR-Admin-ExpiredAlert-button")}
      </button>
    );
  };
  return (
    <>
      <CardAlertBase
        cardFields={[
          {
            title: t("AgentCSR-Admin-ExpiredAlert-title-1"),
            value: convertToTitleCase(alert?.portal),
          },
          {
            title: "",
            value: "",
          },
          {
            title: t("AgentCSR-Admin-ExpiredAlert-title-2"),
            value: convertToTitleCase(alert?.group),
          },
          {
            title: t("AgentCSR-Admin-ExpiredAlert-title-3"),
            value: convertToTitleCase(
              getCSRAdminPortalPae(alert?.userView, alert?.group)
            ),
          },
          {
            title: t("AgentCSR-Admin-ExpiredAlert-title-4"),
            value: moment(alert?.startDate).format("MM/DD/YYYY"),
          },
          {
            title: t("AgentCSR-Admin-ExpiredAlert-title-5"),
            value: moment(alert?.endDate).format("MM/DD/YYYY"),
          },
        ]}
      >
        <ViewMessage />
      </CardAlertBase>
      <SiteWideAlertModal
        title={t("AgentCSR-Admin-ExpiredAlert-SiteWideAlertModal-title")}
        description={alert?.message}
        showCloseIcon={false}
        enablePrimaryButton={false}
        enableSecondaryButton={false}
        dialogState={openAlertMessage}
        setDialogState={setOpenAlertMessage}
        showCloseButton={true}
      />
    </>
  );
}
